import appLocaleData from 'react-intl/locale-data/en'
import enMessages from './en-US.messages.json'

export default {
  messages: {
    ...enMessages,
  },
  locale: 'en-US',
  data: appLocaleData,
}



// WEBPACK FOOTER //
// ./src/locales/en-US.js